const allowBuy = (storeIsSelected, totalStock, storeStock) => {
  return (storeIsSelected && storeStock > 0) || (!storeIsSelected && totalStock > 0)
}

module.exports = { allowBuy }
